// extracted by mini-css-extract-plugin
export default {"about":"About_about__U6j+1","hero":"About_hero__51bO8","heroImage":"About_heroImage__DznYw","heroText":"About_heroText__6-JOb","content":"About_content__akggm"};